import { render, staticRenderFns } from "./CustomNotifyMessage.vue?vue&type=template&id=8a663dae&"
import script from "./CustomNotifyMessage.vue?vue&type=script&lang=js&"
export * from "./CustomNotifyMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports